/*
 * @Author: Ximen
 * @Date: 2020-12-30 11:07:14
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-08 17:25:12
 */
import apiService from './apiService';

const commonApi = {
  // 登录
  login: (parm: object) => apiService().noLogin('/ssoapi/v2/shop/shopLogin', parm),
  // 注册
  registerShop: (param: object) => apiService().noLogin('/ssoapi/v2/shop/registerShop', param),
  // 查看店铺信息
  getShopInfo: (param: object) => apiService().get('/ssoapi/v2/shop/getShopInfo', param),
  // 创建店铺
  createShop: (param: object) => apiService().get('/ssoapi/v2/shop/createShop', param),
  // 认证
  submitShopVerify: (param: object) => apiService().post('/ssoapi/v2/shop/submitShopVerify', param, param),
  // 图片上传
  uploadImg: (param: object) => apiService().post('/api/v2/base/uploadImg', param, param, true),
  // 获取种类
  getDataConfForSaas: (param: object) => apiService().get('/api/v2/payment/getDataConfForSaas', param, true),
  // 支付
  upgradePay: (param: object) => apiService().get('/api/v2/payment/upgradePay', param, true),
  // 获取支付方式
  getPayChannels: (param: object) => apiService().get('/api/v2/payment/getPayChannels', param, true),
  // 发送注册短信
  sendRegisterCode: (param: object) => apiService().get('/ssoapi/v2/shop/sendRegisterCode', param),
  // 发送登录短信
  sendLoginCode: (param: object) => apiService().get('/ssoapi/v2/shop/sendLoginCode', param),
  // 重置密码
  modifyShopPassword: (param: object) => apiService().get('/ssoapi/v2/shop/modifyShopPassword', param),
  // 忘记密码短信
  sendResetCode: (param: object) => apiService().get('/ssoapi/v2/shop/sendResetCode', param),
  // 确认验证码
  checkResetCode: (param: object) => apiService().get('/ssoapi/v2/shop/checkResetCode', param),
  // 查询支付结果
  queryPayStatus: (param: object) => apiService().get('/api/v2/payment/queryPayStatus', param, true),
  // 付费记录列表
  getSaasUpgradePayLists: (param: object) => apiService().get('/api/v2/finance/getSaasUpgradePayLists', param, true),
  // 付费记录详情
  getSaasUpgradePayDetail: (param: object) => apiService().get('/api/v2/finance/getSaasUpgradePayDetail', param, true),
  // 添加意向客户信息
  addVersion: (param: object) => apiService().get('/software/addVersion', param),
};
export default commonApi;
